<script>

export default {
  data() {
    return {
      loading: true,
      cur_month: '',
      items: [],
      filters: {
        page: 1,
        paginate: 7,
        total: 0,
        selects: [
          'id',
          'name',
          'subject',
          'unseen',
          'created_at',
        ],
        whereins: {
          website: [],
        },
        // wheres: {
        //   unseen: 1,
        // },
        orderbys: {
          unseen: 'DESC',
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.cur_month = this.moment();
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/inbox/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.items = res.data.data;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div class="card-box p-0 position-relative" id="print-faq_view_chart">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="p-3">
      <div class="float-right">
        <div class="form-inline">
          <button type="button" class="btn btn-light ml-2 print_target" target="print-faq_view_chart" v-tippy title="Print"><Icon icon="ri:printer-line" /></button>
          <w-field class="ml-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
        </div>
      </div>
      <h4 class="header-title"><Icon icon="ri:mail-open-line" /> Inbox</h4>
      <p class="m-0 small">Most recent unseen entries followed by most resent seen entries</p>
    </div>
    <div class="table-responsive m-0">
      <table class="table table-bordered-right table-hover mb-0 table-centered small">
        <tbody>
          <router-link v-for="(item, index) in items" :key="item.id" :to="'/inbox/'+item.id" tag="tr" class="_c-pointer" :class="item.unseen ? 'border-left _b-s-3 border-primary font-weight-bold' : ''" exact v-tippy content="Click to open this message">
            <td><router-link :to="'/inbox/'+item.id" class="text-secondary"><Icon icon="ri:external-link-line" /> {{item.name}}</router-link></td>
            <td><router-link :to="'/inbox/'+item.id" class="text-secondary">{{item.subject}}</router-link></td>
            <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
